import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Pastry, PastryDto } from '@app/models/pastry.model';
import { environment as env } from '@env';

@Injectable({
  providedIn: 'root'
})
export class PastryService {
  #baseUrl = `${env.PROTECTED_URIS["DEMOAPP"]}/v1/database/pastries`;
  #http: HttpClient = inject(HttpClient);

  // Get all pastries
  getPastries$(): Observable<Pastry[]> {
    return this.#http.get<Pastry[]>(`${this.#baseUrl}/all`);
  }

  // Delete all pastries
  deletePastries$(): Observable<Pastry[]>{
    return this.#http.delete<Pastry[]>(`${this.#baseUrl}/eat/all`)
  }

  // Add a new pastry
  addPastry$(pastry: PastryDto): Observable<Pastry> {
    return this.#http.post<Pastry>(`${this.#baseUrl}/bake`, pastry);
  }
}
